module.exports = __webpack_public_path__ + "static/img/reporterrorIcon.f526bf48.png";